module.exports = __webpack_public_path__ + "img/bg-lattice.ab6abcfb.svg";